import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, DatePicker, Form, Modal, Select, Spin, Table } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import moment from "moment";
import logo from "../../assets/images/logo-black.svg";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import { getDropshipLocation } from "../../redux/actions/dropshipSummaryReports.action.js";
import { getAdminLocation } from "../../redux/actions/adminLocation.action.js";
import { getGender } from "../../redux/actions/gender.action.js";
import { CSVLink } from "react-csv";
import { getZip } from "../../redux/actions/zip.action.js";
import { getCity, getCityNew } from "../../redux/actions/city.actions.js";
import { getState, getStateNew } from "../../redux/actions/state.action.js";
import { Link } from "react-router-dom/cjs/react-router-dom.min.js";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import Chart from "react-google-charts";
import { CityChart, DropShipLocationChart } from "../Dashboard/Charts.js";
import ExcelJS from "exceljs";
import { LoadScript } from '@react-google-maps/api';

const REACT_APP_GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY || "";

const containerStyle = {
  width: '100%',
  height: '100vh',
};

const mapOptions = {
  center: { lat: 39.8283, lng: -98.5795 },
  zoom: 5,
  mapId: "YOUR_MAP_ID",
  restriction: {
    latLngBounds: {
      north: 49.38,
      south: 24.52,
      west: -125.0,
      east: -66.95,
    },
    strictBounds: true,
  },
  minZoom: 4,
  maxZoom: 10,
};

const center = {
  lat: 39.8283, // Center of USA
  lng: -98.5795,
};

const usaBounds = {
  north: 49.38,   // top
  south: 24.52,   // bottom
  west: -125.0,   // left
  east: -66.95,   // right
};

const DropshipLocation = ({ token }) => {
  TabTitle("DropShip Location")
  const userName = ReadCookie("name");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const tableRef = useRef(null);
  const { gender, dropshipLocation, zip, usaState, usaCity } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const [loading, setLoading] = useState(false);
  const [excelData, setExcelData] = useState([]);

  const [reportHeatmap, setReportHeatmap] = useState([]);



  const mapRef = useRef(null);
  const zipMarkersRef = useRef([]);
  const cityCirclesRef = useRef([]);

  const [mapKey, setMapKey] = useState(1);

  useEffect(() => {
    dispatch(getGender(token, menuId));
    dispatch(getAdminLocation(token, menuId));
    dispatch(getZip(token));
    dispatch(getCityNew(token));
    dispatch(getStateNew(token));
  }, [dispatch, menuId, token]);

  let __heatmap_init_ = async (values) => {
    let response = await axios({
      method: "POST",
      url: `${BASEURL}getAll/DropShipByLocationHeatMap`,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: {
        from_date: moment(values.from_date).format("MM-DD-YYYY"),
        to_date: moment(values.to_date).format("MM-DD-YYYY"),
        gender_id: values.gender_id === "All" || values.gender_id === undefined ? null : values.gender_id,
        state_id: values.state === "All" || values.state === undefined ? null : values.state,
        city_id: values.city === "All" || values.city === undefined ? null : values.city,
        zip_code: values.zip === "All" || values.zip === undefined ? null : values.zip,
      }
    });
    if (response?.data?.data) {
      setReportHeatmap(response?.data?.data);

      // STEP 1: clear old markers
      zipMarkersRef.current.forEach((m) => m.setMap(null));
      cityCirclesRef.current.forEach((m) => m.setMap(null));

      zipMarkersRef.current = [];
      cityCirclesRef.current = [];

      // STEP 2: reset map instance
      mapRef.current = null;

      // STEP 3: force FULL map remount
      setMapKey((prev) => prev + 1);

      setLoading(false);
    } else {
      console.log("response", response)
    }
  }

  const onFinish = async () => {
    setLoading(true);
    await form.validateFields().then((values) => {
      dispatch(getDropshipLocation(token, values)).then((res) => {
        if (res.type === "GET_DROPSHIP_LOCATION_REPORTS_SUCCESS") {
          // setLoading(false);
          console.log("res", res)
          // downloadExcelFileData(res?.payload?.data);
          __heatmap_init_(values);
        }
      });
    }).catch((error) => {
      setLoading(false);
    })
  }

  const exportDropshipLocationToExcel = async (data) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Dropship Location");

    worksheet.columns = [
      { header: "Country", key: "country_name", width: 20 },
      { header: "State", key: "state_name", width: 20 },
      { header: "City", key: "city_name", width: 20 },
      { header: "Zip", key: "zip_code", width: 15 },
      { header: "Gender", key: "gender_name", width: 10 },
      { header: "Bloomingdales-Dropship Inv#", key: "bloom_inv_count", width: 25 },
      { header: "Bloomingdales-Dropship NET U", key: "bloom_net", width: 25 },
      { header: "Dia SHOP - FullBeauty Brands Inv#", key: "dia_inv_count", width: 15 },
      { header: "Dia SHOP - FullBeauty Brands NET U", key: "dia_net", width: 15 },
      { header: "Nord D2C Inv#", key: "nord_inv_count", width: 15 },
      { header: "Nord D2C NET U", key: "nord_net", width: 15 },
      { header: "Ecommerce Inv#", key: "ecom_inv_count", width: 15 },
      { header: "Ecommerce NET U", key: "ecom_net", width: 15 },
      { header: "Total Inv#", key: "total_inv_count", width: 15 },
      { header: "Total NET U", key: "total_net", width: 15 },
    ];

    data.forEach((v) => {
      worksheet.addRow({
        country_name: v.country_name,
        state_name: v.state_name,
        city_name: v.city_name,
        zip_code: v.zip_code ? v.zip_code.toString() : "",
        gender_name: v.gender_name,
        bloom_inv_count: v.bloom_inv_count,
        bloom_net: v.bloom_net,
        dia_inv_count: v.dia_inv_count,
        dia_net: v.dia_net,
        nord_inv_count: v.nord_inv_count,
        nord_net: v.nord_net,
        ecom_inv_count: v.ecom_inv_count,
        ecom_net: v.ecom_net,
        total_inv_count: v.total_inv_count,
        total_net: v.total_net,
      });
    });

    // Set Zip column format as text '@' to keep leading zeros
    const zipColumn = worksheet.getColumn("zip_code");
    zipColumn.numFmt = "@";
    zipColumn.eachCell((cell) => {
      cell.value = cell.value ? cell.value.toString() : "";
      cell.numFmt = "@";
    });

    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Dropship-Location.xlsx";
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error writing excel file: ", error);
    }
  };

  const handlePrint = () => {
    window.print();
  };


  const from_date = form.getFieldValue("from_date")
    ? form.getFieldValue("from_date").format("MM-DD-YYYY")
    : null;

  const to_date = form.getFieldValue("to_date")
    ? form.getFieldValue("to_date").format("MM-DD-YYYY")
    : null;

  const columns = [
    {
      title: "#",
      className: "b_bottom",
      render: (text, record, index) => {
        return index + 1
      },
      width: "20px"
    },
    {
      title: "Country",
      dataIndex: "country_name",
      key: "country_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.country_name !== null) & (b.country_name !== null)) {
          return a.country_name.localeCompare(b.country_name);
        }
      }
    },
    {
      title: "State",
      dataIndex: "state_name",
      key: "state_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.state_name !== null) & (b.state_name !== null)) {
          return a.state_name.localeCompare(b.state_name);
        }
      }
    },
    {
      title: "City",
      dataIndex: "city_name",
      key: "city_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.city_name !== null) & (b.city_name !== null)) {
          return a.city_name.localeCompare(b.city_name);
        }
      }
    },
    {
      title: "Zip",
      dataIndex: "zip_code",
      key: "zip_code",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.zip_code - b.zip_code
      },
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.gender_name !== null) & (b.gender_name !== null)) {
          return a.gender_name.localeCompare(b.gender_name);
        }
      }
    },
    {
      title: "Bloomingdales-Dropship",
      children: [
        {
          title: "Inv #",
          dataIndex: "bloom_inv_count",
          key: "bloom_inv_count",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                <span style={{ padding: "10px" }}>{text}</span>
              </>
            );
          },
          sorter: (a, b) => {
            return a.bloom_inv_count - b.bloom_inv_count;
          },
        },
        {
          title: "Net",
          dataIndex: "bloom_net",
          key: "bloom_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            if (text === 0 || text === "0") {
              return <span style={{ padding: "10px" }}>{text}</span>;
            }
            return (
              <Link
                style={{ color: "blue", padding: "10px", textDecoration: "none" }}
                target="_blank"
                rel="noopener noreferrer"
                to={{
                  pathname: `/dropship-location-by-zip`,
                  search: `?from_date=${from_date}&to_date=${to_date}&gender_id=${record?.gender_id}&zip_code=${record?.zip_code}&customer_id=${"1575158"}`
                }}
              >
                {text}
              </Link>
            );
          },
          sorter: (a, b) => {
            return a.bloom_net - b.bloom_net;
          },
        },
      ]
    },
    {
      title: "Dia SHOP - FullBeauty Brands",
      children: [
        {
          title: "Inv #",
          dataIndex: "dia_inv_count",
          key: "dia_inv_count",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                <span style={{ padding: "10px" }}>{text}</span>
              </>
            );
          },
          sorter: (a, b) => {
            return a.dia_inv_count - b.dia_inv_count;
          },
        },
        {
          title: "Net",
          dataIndex: "dia_net",
          key: "dia_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            if (text === 0 || text === "0") {
              return <span style={{ padding: "10px" }}>{text}</span>;
            }
            return (
              <Link
                style={{ color: "blue", padding: "10px", textDecoration: "none" }}
                target="_blank"
                rel="noopener noreferrer"
                to={{
                  pathname: `/dropship-location-by-zip`,
                  search: `?from_date=${from_date}&to_date=${to_date}&gender_id=${record?.gender_id}&zip_code=${record?.zip_code}&customer_id=${"1575177"}`
                }}
              >
                {text}
              </Link>
            );
          },
          sorter: (a, b) => {
            return a.dia_net - b.dia_net;
          },
        },
      ]
    },
    {
      title: "Nordstrom D2C",
      children: [
        {
          title: "Inv #",
          dataIndex: "nord_inv_count",
          key: "nord_inv_count",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                <span style={{ padding: "10px" }}>{text}</span>
              </>
            );
          },
          sorter: (a, b) => {
            return a.nord_inv_count - b.nord_inv_count;
          },
        },
        {
          title: "Net",
          dataIndex: "nord_net",
          key: "nord_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            if (text === 0 || text === "0") {
              return <span style={{ padding: "10px" }}>{text}</span>;
            }
            return (
              <Link
                style={{ color: "blue", padding: "10px", textDecoration: "none" }}
                target="_blank"
                rel="noopener noreferrer"
                to={{
                  pathname: `/dropship-location-by-zip`,
                  search: `?from_date=${from_date}&to_date=${to_date}&gender_id=${record?.gender_id}&zip_code=${record?.zip_code}&customer_id=${"20029"}`
                }}
              >
                {text}
              </Link>
            );
          },
          sorter: (a, b) => {
            return a.nord_net - b.nord_net;
          },
        },
      ]
    },
    {
      title: "Ecommerce",
      children: [
        {
          title: "Inv #",
          dataIndex: "ecom_inv_count",
          key: "ecom_inv_count",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                <span style={{ padding: "10px" }}>{text}</span>
              </>
            );
          },
          sorter: (a, b) => {
            return a.ecom_inv_count - b.ecom_inv_count;
          },
        },
        {
          title: "Net",
          dataIndex: "ecom_net",
          key: "ecom_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            if (text === 0 || text === "0") {
              return <span style={{ padding: "10px" }}>{text}</span>;
            }
            return (
              <Link
                style={{ color: "blue", padding: "10px", textDecoration: "none" }}
                target="_blank"
                rel="noopener noreferrer"
                to={{
                  pathname: `/dropship-location-by-zip`,
                  search: `?from_date=${from_date}&to_date=${to_date}&gender_id=${record?.gender_id}&zip_code=${record?.zip_code}&customer_id=${"1"}`
                }}
              >
                {text}
              </Link>
            );
          },
          sorter: (a, b) => {
            return a.ecom_net - b.ecom_net;
          },
        },
      ]
    },
    {
      title: "Total",
      children: [
        {
          title: "Inv #",
          dataIndex: "total_inv_count",
          key: "total_inv_count",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                <span style={{ padding: "10px" }}>{text}</span>
              </>
            );
          },
          sorter: (a, b) => {
            return a.total_inv_count - b.total_inv_count;
          },
        },
        {
          title: "Net",
          dataIndex: "total_net",
          key: "total_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            if (text === 0 || text === "0") {
              return <span style={{ padding: "10px" }}>{text}</span>;
            }
            return (
              <Link
                style={{ color: "blue", padding: "10px", textDecoration: "none" }}
                target="_blank"
                rel="noopener noreferrer"
                to={{
                  pathname: `/dropship-location-by-zip`,
                  search: `?from_date=${from_date}&to_date=${to_date}&gender_id=${"null"}&zip_code=${record?.zip_code}&customer_id=${"null"}`
                }}
              >
                {text}
              </Link>
            );
          },
          sorter: (a, b) => {
            return a.total_net - b.total_net;
          },
        },
      ]
    },
    // {
    //   title: "Total",
    //   dataIndex: "total_net",
    //   key: "total_net",
    //   className: " b_left b_bottom",
    //   align: "right",
    //   render: (text, record) => {
    //     if (text === 0 || text === "0") {
    //       return <span style={{ padding: "10px" }}>{text}</span>;
    //     }
    //     return (
    //       <>
    //         <Link
    //           style={{ color: "blue", padding: "10px", textDecoration: "none" }}
    //           target="_blank"
    //           rel="noopener noreferrer"
    //           to={{ pathname: `/dropship-location-by-zip`, search: `?from_date=${from_date}&to_date=${to_date}&gender_id=${"null"}&zip_code=${record?.zip_code}&customer_id=${"null"}` }}
    //         >  {text}
    //         </Link>
    //       </>
    //     );
    //   },
    //   sorter: (a, b) => {
    //     return a.total_net - b.total_net
    //   },
    // },
  ];


  //🔹 Group ZIPs by city and SUM total sales
  const cityData = Object.values(
    reportHeatmap.reduce((acc, item) => {
      if (!acc[item.city_name]) {
        acc[item.city_name] = {
          city_name: item.city_name,
          lat: Number(item.lat),
          lng: Number(item.lng),
          totalSales: 0,
        };
      }
      acc[item.city_name].totalSales += Number(item.sales);
      return acc;
    }, {})
  );

  const onLoad = (map) => {
    mapRef.current = map;

    if (!reportHeatmap.length) return;

    const { AdvancedMarkerElement } = window.google.maps.marker;
    const infoWindow = new window.google.maps.InfoWindow();

    const minSales = Math.min(...reportHeatmap.map((z) => z.sales));
    const maxSales = Math.max(...reportHeatmap.map((z) => z.sales));

    // -------------------------------
    // 🟢 ZIP LEVEL MARKERS
    // -------------------------------
    zipMarkersRef.current = reportHeatmap.map((loc) => {
      const size =
        10 + ((loc.sales - minSales) / (maxSales - minSales)) * 20;

      const maxValue = Math.max(...loc.data.map((item) => item.value));
      const maxValueObj = loc.data.find(
        (item) => item.value === maxValue
      );

      const markerDiv = document.createElement("div");
      markerDiv.style.width = `${size}px`;
      markerDiv.style.height = `${size}px`;
      markerDiv.style.borderRadius = "50%";
      markerDiv.style.background = maxValueObj.color;
      markerDiv.style.border = "2px solid white";
      markerDiv.style.boxShadow = "0 0 8px rgba(0,0,0,0.3)";
      markerDiv.style.cursor = "pointer";

      const marker = new AdvancedMarkerElement({
        map,
        position: { lat: Number(loc.lat), lng: Number(loc.lng) },
        content: markerDiv,
      });

      marker.addListener("click", () => {
        infoWindow.setContent(`
          <b>${loc.city_name}</b><br/>
          ZIP: ${loc.zip_code}<br/>
          <h4 style="text-align:center">Customers</h4>
          ${loc.data
            .filter((x) => x.value !== 0)
            .map(
              (item) => `
            <div style="display:flex;align-items:center;margin-bottom:6px;">
              <div style="
                width:14px;height:14px;background:${item.color};
                border:1px solid #ccc;margin-right:8px;border-radius:3px;">
              </div>
              <b>${item.name}</b> = ${item.value}
            </div>`
            )
            .join("")}
          <br/>Total Sales: ${loc.sales}
        `);

        infoWindow.open({ anchor: marker, map });
      });

      return marker;
    });

    // -------------------------------
    // 🟠 CITY LEVEL CIRCLES
    // -------------------------------
    cityCirclesRef.current = cityData.map((city) => {
      const normalized =
        (city.totalSales - minSales) / (maxSales - minSales);

      const size = 10 + Math.pow(normalized, 0.4) * 20;

      const div = document.createElement("div");
      div.style.width = `${size}px`;
      div.style.height = `${size}px`;
      div.style.borderRadius = "50%";
      div.style.background = "red";
      div.style.opacity = "0.75";
      div.style.border = "2px solid white";

      const marker = new AdvancedMarkerElement({
        map,
        position: { lat: Number(city.lat), lng: Number(city.lng) },
        content: div,
      });

      // 🟢 Use shared infoWindow (same as ZIP)
      marker.addListener("click", () => {
        infoWindow.setContent(`
          <div style="text-align:center;">
            <b>${city.city_name}</b><br/>
            Total Sales: ${city.totalSales}
          </div>
        `);

        infoWindow.open({ anchor: marker, map });
      });

      return marker;
    });


    // -------------------------------
    // 🔍 ZOOM BASED VISIBILITY
    // -------------------------------
    const toggleLayers = () => {
      const zoom = map.getZoom();

      if (zoom <= 8) {
        zipMarkersRef.current.forEach((m) => m.setMap(null));
        cityCirclesRef.current.forEach((c) => c.setMap(map));
      } else {
        zipMarkersRef.current.forEach((m) => m.setMap(map));
        cityCirclesRef.current.forEach((c) => c.setMap(null));
      }
    };

    toggleLayers();
    map.addListener("zoom_changed", toggleLayers);
  };


  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between pb-0">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>

                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                          onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class">
                        {dropshipLocation?.payload?.data ? (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                            onClick={() => exportDropshipLocationToExcel(dropshipLocation?.payload?.data)}
                          />
                        ) : (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                          />
                        )}
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Dropship Location
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>

                    </span>
                  </div>
                </div>
              </div>
              <div className="row pb-2">
                <div className="col">
                  <Form
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <div className="main_form row">
                      <div className="col-12">
                        <hr className="my-1" />
                        <div className="row">
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="gender_id" className="labels width30">
                                From:
                              </label>
                              <div style={{ marginBottom: "-2px" }} className=" w-100">
                                <Form.Item
                                  className="formFullWidth"
                                  name="from_date"
                                  initialValue={moment().startOf("year")}
                                >
                                  <DatePicker
                                    size="small"
                                    defaultValue={moment().format("MM-DD-YYYY")}
                                    className={"select_Inputs"}
                                    format={"MM-DD-YYYY"}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="gender_id" className="labels width30">
                                To:
                              </label>
                              <div style={{ marginBottom: "-2px" }} className=" w-100">
                                <Form.Item
                                  className="formFullWidth"
                                  name="to_date"
                                  initialValue={moment().endOf("year")}
                                >
                                  <DatePicker
                                    size="small"
                                    defaultValue={moment().format("MM-DD-YYYY")}
                                    className={"select_Inputs"}
                                    format={"MM-DD-YYYY"}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width30">Gender:</label>
                              <div className=" w-100">
                                <Form.Item name="gender_id" initialValue={"All"}>
                                  <Select
                                    className="formFullWidth"
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value="All">All</Option>
                                    {gender &&
                                      gender?.payload?.data.map((it, index) => {
                                        return (
                                          <Option key={index} value={it.gender_id}>
                                            {it.gender_name}
                                          </Option>
                                        );
                                      })}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width30">State:</label>
                              <div className=" w-100">
                                <Form.Item name="state" initialValue={"All"}>
                                  <Select
                                    className={"select_Inputs"}
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value="All">All</Option>
                                    {usaState &&
                                      usaState?.payload?.data.map((it, index) => {
                                        return (
                                          <Option key={index} value={it.state_id}>
                                            {it.state_name}
                                          </Option>
                                        );
                                      })}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width30">City:</label>
                              <div className=" w-100">
                                <Form.Item name="city" initialValue={"All"}>
                                  <Select
                                    className={"select_Inputs"}
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value="All">All</Option>
                                    {usaCity &&
                                      usaCity?.payload?.data.map((it, index) => {
                                        return (
                                          <Option key={index} value={it.city_id}>
                                            {it.city_name}
                                          </Option>
                                        );
                                      })}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width30">Zip:</label>
                              <div className=" w-100">
                                <Form.Item name="zip" initialValue={"All"}>
                                  <Select
                                    className={"select_Inputs"}
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value="All">All</Option>
                                    {zip &&
                                      zip?.payload?.data.map((it, index) => {
                                        return (
                                          <Option key={index} value={it.zip_code}>
                                            {it.zip_code}
                                          </Option>
                                        );
                                      })}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="row">
                              <div style={{ marginTop: "3px", display: "flex", justifyContent: "left" }} >
                                <Button type="primary" htmlType="submit" className='submit-btn-btm m-0' disabled={loading}>
                                  Search
                                </Button>
                                {/* </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table_content"
        style={{
          width: "100%"
        }}
        ref={tableRef} >
        <div >
          {loading ? (
            <div className="d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin />
            </div>
          ) : dropshipLocation?.payload?.data.length ? (
            <div>
              {/* HEATMAP */}
              <div>
                <div className="charts_container">
                  <LoadScript
                    googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
                    libraries={["marker"]}
                  >
                    <div
                      id="map"
                      key={mapKey} // 🔥 forces map re-render
                      style={{ width: "100%", height: "600px" }}
                      ref={(ref) => {
                        if (ref && !mapRef.current && window.google) {
                          const map = new window.google.maps.Map(ref, mapOptions);
                          onLoad(map);
                        }
                      }}
                    />
                  </LoadScript>

                  {/* LEGEND */}

                  <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", marginTop: "16px", gap: "12px" }}>
                    {
                      reportHeatmap && reportHeatmap[0]?.data?.map((item) => {
                        return (
                          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <div
                              style={{
                                width: "50px",
                                height: "15px",
                                backgroundColor: item.color,
                                border: "1px solid #ccc",
                                borderRadius: "3px"
                              }}
                            ></div>
                            <span style={{ fontSize: "13px" }}>{item.name}</span>
                          </div>
                        )
                      })
                    }
                  </div>



                </div>
              </div>


              <Table
                style={{ fontSize: '10.3px' }}
                className="test04 mt-3 sales_target_report_table sales_report_res_table_intransit ledger_print speciality_customer_size sales_report_res_table dropship-table-height"
                size="small"
                pagination={{
                  defaultCurrent: 1,
                  defaultPageSize: 100,
                  pageSizeOptions: [100, 500, 1000]
                }}
                summary={() => {
                  const allData = Array.isArray(dropshipLocation?.payload?.data)
                    ? dropshipLocation.payload.data
                    : [];

                  const sumField = (field) =>
                    allData.reduce(
                      (total, item) => total + (parseFloat(item?.[field]) || 0),
                      0
                    );

                  const blmngInv = sumField('bloom_inv_count');
                  const blmngNet = sumField('bloom_net');
                  const diaInv = sumField('dia_inv_count');
                  const diaNet = sumField('dia_net');
                  const nordInv = sumField('nord_inv_count');
                  const nordNet = sumField('nord_net');
                  const ecomInv = sumField('ecom_inv_count');
                  const ecomNet = sumField('ecom_net');
                  const totalInv = sumField('total_inv_count');
                  const totalNet = sumField('total_net');

                  return (
                    <Table.Summary.Row>
                      <Table.Summary.Cell colSpan={5}></Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right" }}>Overall Total</p>
                      </Table.Summary.Cell>
                      {[blmngInv, blmngNet,
                        diaInv, diaNet,
                        nordInv, nordNet,
                        ecomInv, ecomNet,
                        totalInv, totalNet].map((val, idx) => (
                          <Table.Summary.Cell key={idx} className="sales_table_summary">
                            <p
                              style={{
                                fontWeight: "bolder",
                                textAlign: "right",
                                width: "100%",
                                borderTop: "1px solid black",
                                borderBottom: "1px solid black",
                                fontSize: "11.3px",
                                paddingRight: "9px",
                              }}
                            >
                              {numeral(val).format("0,0")}
                            </p>
                          </Table.Summary.Cell>
                        ))}
                    </Table.Summary.Row>
                  );
                }}
                bordered
                columns={columns}
                scroll={{ x: "max-content" }}
                dataSource={dropshipLocation?.payload?.data}
              />

            </div>
          ) : (
            <div
              style={{
                backgroundColor: '#CCCCCC',
                borderWidth: '1pt',
                borderStyle: 'Dashed',
                fontWeight: 'bold',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No record(s)
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DropshipLocation;

